/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_List_Filter_No_SponsorInputs */



/**
* | output |
* | --- |
* | "No sponsor" |
*
* @param {User_List_Filter_No_SponsorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_list_filter_no_sponsor = /** @type {((inputs?: User_List_Filter_No_SponsorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_List_Filter_No_SponsorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sans parrain")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin patrocinador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sem patrocinador")
	if (locale === "it") return /** @type {LocalizedString} */ ("Senza sponsor")
	return /** @type {LocalizedString} */ ("No sponsor")
});